import React, { useMemo } from 'react';
import { ServerGroup } from 'src/orchd-client';
import { useIntl } from 'react-intl';

import { Box } from 'src/components/Box';
import { SelectField } from 'src/components/Select';
import { getSelectFieldValue } from 'src/utils/helpers';

interface RequiredProps {
  serverGroups: ServerGroup[];
  currentServerGroupId?: string;
  onServerGroupChange: (serverGroupId: string) => void;
}

export const ServerGroupSelector = ({ serverGroups, currentServerGroupId, onServerGroupChange }: RequiredProps) => {
  const { formatMessage } = useIntl();

  const options = useMemo(() => {
    return serverGroups.map(({ id, name }) => ({ value: id, label: name }));
  }, [serverGroups]);

  return (
    <Box g="xl">
      <Box mb="2xl" w={{ xs: 12, sm: 6 }}>
        <SelectField
          name="serverGroupId"
          label="Server group"
          placeholder={formatMessage({ id: 'add_website.select_server_group', defaultMessage: 'Select server group' })}
          onChange={({ value }) => onServerGroupChange(getSelectFieldValue(value) as string)}
          value={options.find(({ value }) => value === currentServerGroupId)}
          options={options}
        />
      </Box>
    </Box>
  );
};
